import { SxProps, Theme } from '@mui/material/styles';

// ValuationMethodDescription styles
export const valuationMethodDescriptionSx: SxProps<Theme> = {
  mt: 1,
};

// ValuationSettingsForm styles
export const formContainerSx = (theme: Theme): SxProps<Theme> => ({
  marginTop: theme.spacing(0),
});

// FormHeader styles
export const formHeaderTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 1,
};

export const formHeaderDescriptionSx: SxProps<Theme> = {
  mb: 2,
};
